// future-fabric page bundle -> dist/js/pages/future-fabric.min.js
//
// Plain-ES port of the v3 future-fabric interactions (originally a React/DCLogic
// component: people-equation/dc/future-fabric.logic.js on feat/v3-design-pages).
// No framework: nodes are re-selected via data-* hooks. Props are hardcoded to
// the v3 defaults (fabricDensity 1, linkReach 1, aiNodes true, showSystemStrip
// true, panelTone teal -> #103F3E, sweepSpeed 1, sweepOnEntry true).
//
// Ported behaviours:
//   - the hero "fabric" <canvas> visual (2D + requestAnimationFrame, six strands
//     morphing pyramid -> hourglass -> ... -> ecosystem, nodes travelling, faint
//     cross-ties, pointer parallax) + the timer watchdog;
//   - the capability picker (tab click switches active row + detail panel);
//   - the "how we work" spine (entry sweep on scroll-in + per-principle hover
//     sweep that lights each node along the line);
//   - the leadership profile drawer (card hover, open/close, 580ms settle,
//     Escape + veil close, focus + body lock) reading #pe-ff-people;
//   - the "select clientele" marquee (hover pauses the drift; a logo's "+"
//     floats its testimonial card);
//   - the insights card hover (image drift + tint + arrow step);
//   - the closing CTA rise-in.
// The shared nav interactions (scroll auto-hide, dropdown panels, mobile menu)
// live in chrome.js and load on every page.

(function () {
  "use strict";

  var root = document.querySelector(".pe-ff");
  if (!root) return;

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var reduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  // Hardcoded v3 props.
  var PROP = { density: 1, link: 1, ai: true, sweep: 1, sweepEntry: true, tone: "#103F3E" };

  /* ======================= hero fabric canvas ============================ */
  var cv = $("[data-ff-canvas]");
  var ctx = null;
  var W = 1, H = 1, nodes = null, SHAPES = null;
  var t = 0, t0 = 0, lastFrame = 0, raf = null, watch = null;
  var mtx = 0, mty = 0, px = 0, py = 0;
  var K = 10, SN = 6, HOLD = 3.5, MORPH = 2.7;

  function hz(w, y) { var p = []; for (var i = 0; i < K; i++) p.push([0.5 - w / 2 + w * (i / (K - 1)), y]); return p; }
  function vt(x, y0, y1) { var p = []; for (var i = 0; i < K; i++) p.push([x, y0 + (y1 - y0) * (i / (K - 1))]); return p; }
  function ring(cx, cy, r, rot) {
    var p = [];
    for (var i = 0; i < K; i++) {
      var a = (rot || 0) + (i / (K - 1)) * Math.PI * 2;
      p.push([cx + Math.cos(a) * r, cy + Math.sin(a) * r * 0.98]);
    }
    return p;
  }
  function buildShapes() {
    var tiers = function (ws) { return ws.map(function (w, i) { return hz(w, 0.16 + i * 0.135); }); };
    // Ring/circle morph states were removed on request: the "3 circles top +
    // bottom" grid and the "concentric electron rings" no longer feature in the
    // hero cycle. Only the woven-tier + grid states remain. ring() is kept above
    // in case the states are ever restored. The cycle length now follows
    // SHAPES.length (see frame()), not the fixed SN, so dropping states here is
    // enough — SN still counts the six strands every remaining state carries.
    void ring;
    SHAPES = [
      tiers([0.10, 0.24, 0.38, 0.52, 0.66, 0.80]),
      tiers([0.68, 0.44, 0.15, 0.15, 0.44, 0.68]),
      tiers([0.80, 0.66, 0.52, 0.38, 0.24, 0.10]),
      [hz(0.74, 0.22), vt(0.24, 0.14, 0.86), hz(0.74, 0.50), vt(0.50, 0.14, 0.86), hz(0.74, 0.78), vt(0.76, 0.14, 0.86)]
    ];
  }
  function counts() {
    var d = Math.max(0.6, Math.min(1.4, PROP.density));
    return Math.max(8, Math.round(17 * d));
  }
  function deal(init) {
    if (!SHAPES) buildShapes();
    if (!init && nodes) return;
    var n = counts();
    nodes = [];
    for (var i = 0; i < n; i++) {
      var isAi = PROP.ai && i % 4 === 1;
      nodes.push({
        s: i % SN,
        u: (i * 0.137 + (i % 3) * 0.21) % 1,
        v: (0.019 + (i % 5) * 0.0055) * (i % 2 ? 1 : -1),
        r: 1.9 + (i % 4) * 0.42,
        ph: i * 1.31,
        ai: isAi,
        accent: !isAi && i % 6 === 2,
        delay: (i % SN) * 0.09
      });
    }
  }
  function layoutCanvas() {
    if (!cv) return;
    var vw = window.innerWidth;
    var narrow = vw < 900;
    cv.style.width = narrow ? "100%" : (vw < 1200 ? "54%" : "58%");
    // Full opacity everywhere. The old .42 dimmed the narrow canvas because it
    // used to overlap the headline; it now sits stacked below the copy (see the
    // hero stacking rule in future-fabric.scss), so it can read at full strength.
    cv.style.opacity = "1";
    cv.style.maskImage = narrow
      ? "linear-gradient(to bottom,transparent 0%,rgba(0,0,0,1) 46%)"
      : "linear-gradient(to right,transparent 0%,rgba(0,0,0,1) 26%,rgba(0,0,0,1) 94%,transparent 100%)";
    cv.style.webkitMaskImage = cv.style.maskImage;
  }
  function sizeFabric() {
    if (!cv || !ctx) return;
    var r = cv.getBoundingClientRect();
    W = Math.max(1, r.width);
    H = Math.max(1, r.height);
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    cv.width = Math.round(W * dpr);
    cv.height = Math.round(H * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    deal(true);
  }
  function strand(si, a, b, m) {
    var A = SHAPES[a][si], B = SHAPES[b][si], out = [];
    for (var i = 0; i < K; i++) out.push([A[i][0] + (B[i][0] - A[i][0]) * m, A[i][1] + (B[i][1] - A[i][1]) * m]);
    return out;
  }
  function sample(pts, u) {
    var f = Math.max(0, Math.min(0.9999, u)) * (K - 1);
    var i = Math.floor(f), k = f - i;
    var p = pts[i], q = pts[Math.min(K - 1, i + 1)];
    return [p[0] + (q[0] - p[0]) * k, p[1] + (q[1] - p[1]) * k];
  }
  function diamond(x, y, r) {
    ctx.beginPath();
    ctx.moveTo(x, y - r); ctx.lineTo(x + r, y); ctx.lineTo(x, y + r); ctx.lineTo(x - r, y);
    ctx.closePath();
  }
  function frame() {
    if (!cv) return;
    var c = cv.getContext("2d");
    ctx = c;
    if (!c) return;
    if (!nodes || !W) sizeFabric();
    if (!nodes || !SHAPES) return;

    var now = performance.now();
    var dt = Math.min(64, lastFrame ? now - lastFrame : 16);
    lastFrame = now;
    var k = Math.min(1, dt / 16);
    var entry = reduced ? 1 : Math.min(1, (now - t0) / 2200);
    var soft = function (v) { return v <= 0 ? 0 : v >= 1 ? 1 : 1 - Math.pow(1 - v, 3); };
    t += reduced ? 0 : dt / 1000;

    // Cycle over however many morph states SHAPES actually holds (the ring
    // states were removed) — NOT the fixed SN, which still counts the six
    // strands each state carries.
    var NS = SHAPES.length;
    var span = HOLD + MORPH;
    var total = NS * span;
    var cyc = ((t % total) + total) % total;
    var a = Math.floor(cyc / span) % NS;
    var b = (a + 1) % NS;
    var loc = cyc - a * span;
    var mr = loc <= HOLD ? 0 : (loc - HOLD) / MORPH;
    var m = mr <= 0 ? 0 : mr >= 1 ? 1 : (mr < 0.5 ? 4 * mr * mr * mr : 1 - Math.pow(-2 * mr + 2, 3) / 2);
    var moving = m > 0.02 && m < 0.98;

    var S = Math.min(W * 0.84, H * 0.92);
    var ox = W * 0.5 - S / 2, oy = H * 0.5 - S / 2;
    var breathe = 1 + Math.sin(t * 0.28) * 0.012;
    var X = function (nx) { return ox + S * 0.5 + (nx - 0.5) * S * breathe; };
    var Y = function (ny) { return oy + S * 0.5 + (ny - 0.5) * S * breathe; };

    px += ((mtx * 9) - px) * 0.045 * k;
    py += ((mty * 6) - py) * 0.045 * k;

    c.clearRect(0, 0, W, H);
    c.save();
    c.translate(px, py);
    c.lineCap = "round";
    c.lineJoin = "round";

    var strands = [];
    for (var si = 0; si < SN; si++) strands.push(strand(si, a, b, m));

    var reach = 0.16 * Math.max(0.6, Math.min(1.6, PROP.link));
    c.lineWidth = 1.4;
    for (si = 0; si < SN - 1; si++) {
      var A = strands[si], B = strands[si + 1];
      for (var i = 1; i < K; i += 3) {
        var p = A[i], q = B[i];
        var d = Math.hypot(p[0] - q[0], p[1] - q[1]);
        if (d > reach * 3.2) continue;
        var al = (1 - d / (reach * 3.2)) * (0.34 + 0.22 * m) * entry;
        if (al < 0.006) continue;
        c.strokeStyle = "rgba(23,114,111," + al.toFixed(3) + ")";
        c.beginPath(); c.moveTo(X(p[0]), Y(p[1])); c.lineTo(X(q[0]), Y(q[1])); c.stroke();
      }
    }

    for (si = 0; si < SN; si++) {
      var pts = strands[si];
      var lp = soft((entry - si * 0.075) / 0.7);
      if (lp <= 0) continue;
      var wob = Math.sin(t * 0.5 + si * 1.2) * 0.0035;
      c.beginPath();
      c.moveTo(X(pts[0][0]), Y(pts[0][1] + wob));
      for (i = 1; i < K - 1; i++) {
        var cx = X(pts[i][0]), cy = Y(pts[i][1] + wob);
        var nx = (pts[i][0] + pts[i + 1][0]) / 2, ny = (pts[i][1] + pts[i + 1][1]) / 2 + wob;
        c.quadraticCurveTo(cx, cy, X(nx), Y(ny));
      }
      c.lineTo(X(pts[K - 1][0]), Y(pts[K - 1][1] + wob));
      c.lineWidth = si === 0 ? 2.2 : 1.9;
      // Darker, near-solid teal so the fabric reads clearly on small screens
      // (the old low-alpha lines washed out). Still fades in via lp on entry.
      c.strokeStyle = "rgba(16,74,72," + Math.min(1, (0.82 + 0.10 * lp + 0.10 * m) * lp).toFixed(3) + ")";
      c.stroke();
      if (moving) {
        c.lineWidth = 2.2;
        c.strokeStyle = "rgba(44,192,200," + (0.09 * Math.sin(Math.PI * m)).toFixed(3) + ")";
        c.stroke();
      }
    }

    for (var ni = 0; ni < nodes.length; ni++) {
      var nn = nodes[ni];
      var pn = soft((entry - nn.delay) / 0.55);
      if (pn <= 0) continue;
      nn.u = (nn.u + nn.v * (dt / 1000) * (moving ? 2.5 : 1) + 1) % 1;
      var s = sample(strands[nn.s], nn.u);
      var off = Math.sin(t * 0.9 + nn.ph) * 0.006;
      var x = X(s[0]), y = Y(s[1] + off);
      var pulse = 0.55 + 0.45 * Math.sin(t * 1.5 + nn.ph);
      if (nn.ai) {
        diamond(x, y, nn.r + 1.3);
        c.fillStyle = "rgba(42,134,140," + ((0.30 + 0.30 * pulse) * pn).toFixed(3) + ")";
        c.fill();
      } else if (nn.accent) {
        c.fillStyle = "rgba(242,103,58," + ((0.46 + 0.32 * pulse) * pn).toFixed(3) + ")";
        c.beginPath(); c.arc(x, y, nn.r + 0.5, 0, Math.PI * 2); c.fill();
      } else {
        c.fillStyle = "rgba(23,114,111," + ((0.28 + 0.30 * pulse) * pn).toFixed(3) + ")";
        c.beginPath(); c.arc(x, y, nn.r, 0, Math.PI * 2); c.fill();
      }
    }
    c.restore();
  }
  function start() {
    stop();
    lastFrame = 0;
    var tick = function () { frame(); if (!reduced) raf = requestAnimationFrame(tick); };
    tick();
    if (!reduced) {
      watch = window.setInterval(function () {
        if (performance.now() - (lastFrame || 0) > 320) frame();
      }, 120);
    }
  }
  function stop() {
    if (raf) cancelAnimationFrame(raf);
    if (watch) window.clearInterval(watch);
    raf = null; watch = null;
  }
  function initFabric() {
    if (!cv) return;
    ctx = cv.getContext("2d");
    mtx = 0; mty = 0; px = 0; py = 0; t = 0;
    t0 = performance.now();
    buildShapes();
    sizeFabric();
    start();
  }
  if (cv) {
    layoutCanvas();
    initFabric();
    window.addEventListener("pointermove", function (e) {
      var r = cv.getBoundingClientRect();
      mtx = Math.max(-1, Math.min(1, ((e.clientX - r.left) / Math.max(1, r.width)) * 2 - 1));
      mty = Math.max(-1, Math.min(1, ((e.clientY - r.top) / Math.max(1, r.height)) * 2 - 1));
    }, { passive: true });
  }

  /* ======================= capability picker ============================= */
  var caps = $("#ff-capabilities");
  var activeCap = 0;
  function applyCaps() {
    if (!caps) return;
    var tone = PROP.tone;
    var stage = $("[data-cap-stage]", caps);
    if (stage) stage.style.background = tone;
    $$("[data-cap-panel]", caps).forEach(function (p) {
      var on = Number(p.getAttribute("data-cap-panel")) === activeCap;
      p.style.opacity = on ? "1" : "0";
      p.style.transform = on ? "none" : "translateY(10px)";
      p.style.pointerEvents = on ? "auto" : "none";
    });
    $$("[data-cap-row]", caps).forEach(function (r) {
      var on = Number(r.getAttribute("data-cap-row")) === activeCap;
      r.style.background = on ? tone : "transparent";
      r.style.color = on ? "#fff" : "#14181A";
      r.setAttribute("aria-selected", on ? "true" : "false");
      var n = r.querySelector("[data-cap-num]"); if (n) n.style.color = on ? "rgba(255,255,255,.6)" : "#2A868C";
      var a = r.querySelector("[data-cap-arrow]"); if (a) a.style.opacity = on ? "1" : "0";
      var bar = r.querySelector("[data-cap-bar]"); if (bar) bar.style.transform = on ? "scaleY(1)" : "scaleY(0)";
    });
  }
  if (caps) {
    $$("[data-cap-row]", caps).forEach(function (r) {
      r.addEventListener("click", function () {
        activeCap = Number(r.getAttribute("data-cap-row")) || 0;
        applyCaps();
      });
    });
  }

  /* ======================= principle spine =============================== */
  var spine = $("#ff-principles");
  var spineOn = false, hoverPrinciple = null, sweepT = [];
  // SSR emits BOTH the desktop (.ff-only-desktop) and mobile (.ff-only-mobile)
  // spine branches (3 [data-principle] cards each); CSS display:none hides
  // whichever one isn't the active width. Scope every spine query to just the
  // visible branch so the sweep/hover/entry logic touches 3 nodes, not 6.
  function spineBranch() {
    if (!spine) return null;
    var wide = window.innerWidth >= 1024;
    return spine.querySelector(wide ? ".ff-only-desktop" : ".ff-only-mobile") || spine;
  }
  function nodeLit(node, on, strong) {
    if (!node) return;
    node.style.background = on ? "#F2673A" : "#FFFFFF";
    node.style.borderColor = on ? "#F2673A" : "#2A868C";
    node.style.transform = "rotate(45deg) scale(" + (on ? (strong ? 1.42 : 1.26) : 1) + ")";
    node.style.boxShadow = on ? "0 0 0 " + (strong ? 6 : 4) + "px rgba(242,103,58,.12)" : "0 0 0 0 rgba(242,103,58,0)";
  }
  function clearSweep() { sweepT.forEach(function (t) { clearTimeout(t); }); sweepT = []; }
  function sweepSpine() {
    if (!spine || reduced) return;
    var wide = window.innerWidth >= 1024;
    var pulse = $(wide ? "[data-spine-pulse]" : "[data-spine-pulse-y]", spine);
    var track = $(wide ? "[data-spine-track]" : "[data-spine-track-y]", spine);
    if (!pulse || !track) return;
    var dur = Math.round(1050 / Math.max(0.6, Math.min(1.8, PROP.sweep)));
    pulse.style.animation = "none";
    void pulse.offsetWidth;
    pulse.style.animation = (wide ? "peSpineX " : "peSpineY ") + dur + "ms cubic-bezier(.34,0,.36,1) 1";
    clearSweep();
    var tr = track.getBoundingClientRect();
    $$("[data-principle]", spineBranch()).forEach(function (p) {
      var node = p.querySelector("[data-node]");
      if (!node) return;
      var nr = node.getBoundingClientRect();
      var raw = wide
        ? ((nr.left + nr.width / 2) - tr.left) / Math.max(1, tr.width)
        : ((nr.top + nr.height / 2) - tr.top) / Math.max(1, tr.height);
      var at = dur * (0.08 + Math.max(0, Math.min(1, raw)) * 0.82);
      sweepT.push(setTimeout(function () { nodeLit(node, true, p === hoverPrinciple); }, at));
      sweepT.push(setTimeout(function () { if (p !== hoverPrinciple) nodeLit(node, false, false); }, at + 340));
    });
  }
  function principleHover(el, on) {
    if (!spine) return;
    hoverPrinciple = on ? el : null;
    var body = el.querySelector("[data-body]"); if (body) body.style.color = on ? "#2E3739" : "#5D6669";
    var title = el.querySelector("[data-title]"); if (title) title.style.color = on ? "#17726F" : "#14181A";
    var rule = el.querySelector("[data-rule]"); if (rule) rule.style.transform = on ? "scaleX(1)" : "scaleX(0)";
    $$("[data-principle]", spineBranch()).forEach(function (p) { p.style.opacity = (!on || p === el) ? "1" : ".74"; });
    var fill = spine.querySelector("[data-spine-fill]"); if (fill) fill.style.opacity = on ? "1" : ".75";
    if (on) { nodeLit(el.querySelector("[data-node]"), true, true); sweepSpine(); }
    else { clearSweep(); $$("[data-node]", spineBranch()).forEach(function (n) { nodeLit(n, false, false); }); }
  }
  function lightSpine() {
    if (!spine) return;
    spineOn = true;
    var fill = spine.querySelector("[data-spine-fill]"); if (fill) fill.style.width = "100%";
    var fillY = spine.querySelector("[data-spine-fill-y]"); if (fillY) fillY.style.height = "100%";
    $$("[data-principle]", spineBranch()).forEach(function (p) { p.style.opacity = "1"; p.style.transform = "none"; });
    if (PROP.sweepEntry) sweepT.push(setTimeout(sweepSpine, 1450));
  }
  if (spine) {
    $$("[data-principle]", spineBranch()).forEach(function (el) {
      el.addEventListener("mouseenter", function () { principleHover(el, true); });
      el.addEventListener("mouseleave", function () { principleHover(el, false); });
    });
    if (reduced || !("IntersectionObserver" in window)) { lightSpine(); }
    else {
      var so = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (e) { if (e.isIntersecting) { lightSpine(); obs.disconnect(); } });
      }, { threshold: 0.28 });
      so.observe(spine);
    }
  }

  /* ======================= leadership drawer ============================= */
  var data = {};
  try { var raw = $("#pe-ff-people"); if (raw) data = JSON.parse(raw.textContent || "{}"); } catch (e) { data = {}; }
  var lead = $("#ff-leadership");
  var drawer = $("[data-drawer]"), veil = $("[data-veil]");
  var drX = $("[data-dr-x]"), drKind = $("[data-dr-kind]"), drScroll = $("[data-dr-scroll]");
  var drImg = $("[data-dr-img]"), drName = $("[data-dr-name]"), drRole = $("[data-dr-role]");
  var drLi = $("[data-dr-li]"), drBio = $("[data-dr-bio]");
  var drState = null, lastFocus = null, animating = false, settleT = null, hoverKey = null;

  function leadHover(card, on) {
    var q = function (k) { return card.querySelector("[data-" + k + "]"); };
    card.style.background = on ? "#F2673A" : "#FFFFFF";
    var bar = q("bar"); if (bar) bar.style.transform = on ? "none" : "scaleX(0)";
    var shot = q("shot"); if (shot) shot.style.transform = on ? "scale(1.035)" : "none";
    var tag = q("tag"); if (tag) tag.style.color = on ? "rgba(20,24,26,.78)" : "#F2673A";
    var role = q("role"); if (role) role.style.color = on ? "rgba(20,24,26,.74)" : "rgba(8,27,28,.54)";
    var more = q("more"); if (more) more.style.color = on ? "#14181A" : "rgba(8,27,28,.52)";
    var plus = q("plus"); if (plus) plus.style.color = on ? "#14181A" : "#F2673A";
  }
  function applyDrawer(animate) {
    if (!drawer || !veil) return;
    var open = !!drState;
    drawer.style.transition = animate ? "transform .52s cubic-bezier(.4,0,.2,1)" : "none";
    veil.style.transition = animate ? "opacity .4s ease" : "none";
    drawer.style.transform = open ? "none" : "translateX(101%)";
    drawer.style.pointerEvents = open ? "auto" : "none";
    veil.style.opacity = open ? "1" : "0";
    veil.style.pointerEvents = open ? "auto" : "none";
    if (open) drawer.removeAttribute("inert"); else drawer.setAttribute("inert", "");
  }
  function fillDrawer(p) {
    if (drKind) drKind.textContent = p && p.kind ? p.kind : "Profile";
    if (drName) drName.textContent = p ? (p.name || "") : "";
    if (drRole) drRole.textContent = p ? (p.role || "") : "";
    if (drLi) drLi.href = p && p.li ? p.li : "#";
    if (drImg) drImg.style.backgroundImage = p && p.img ? 'url("' + p.img + '")' : "none";
    if (drBio) drBio.innerHTML = p && p.bio ? p.bio : "";
  }
  function settle() {
    window.clearTimeout(settleT);
    settleT = window.setTimeout(function () { animating = false; applyDrawer(false); }, 580);
  }
  function openProfile(key, trigger) {
    if (!data[key]) return;
    lastFocus = trigger || null;
    animating = true;
    drState = key;
    fillDrawer(data[key]);
    applyDrawer(true);
    document.body.style.overflow = "hidden";
    if (drScroll) drScroll.scrollTop = 0;
    if (drX) drX.focus();
    settle();
  }
  function closeProfile() {
    if (!drState) return;
    animating = true;
    drState = null;
    applyDrawer(true);
    document.body.style.overflow = "";
    if (lastFocus) lastFocus.focus();
    settle();
  }
  if (lead) {
    $$("[data-p]", lead).forEach(function (card) {
      card.addEventListener("mouseenter", function () { hoverKey = card.dataset.p; leadHover(card, true); });
      card.addEventListener("mouseleave", function () { if (hoverKey === card.dataset.p) hoverKey = null; leadHover(card, false); });
      card.addEventListener("focus", function () { hoverKey = card.dataset.p; leadHover(card, true); });
      card.addEventListener("blur", function () { if (hoverKey === card.dataset.p) hoverKey = null; leadHover(card, false); });
      card.addEventListener("click", function () { openProfile(card.dataset.p, card); });
      card.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") { e.preventDefault(); openProfile(card.dataset.p, card); }
      });
    });
  }
  if (drX) drX.addEventListener("click", closeProfile);
  if (veil) veil.addEventListener("click", closeProfile);
  window.addEventListener("keydown", function (e) { if (e.key === "Escape" && drState) closeProfile(); });

  /* ======================= clientele marquee ============================= */
  var clients = $("#ff-clientele");
  var qT = null;
  function marqueePause(on) {
    if (!clients) return;
    $$("[data-marquee]", clients).forEach(function (t) { t.style.animationPlayState = on ? "paused" : "running"; });
  }
  function quoteShow(btn) {
    if (!clients) return;
    var card = $("[data-tcard]", clients);
    if (!card) return;
    window.clearTimeout(qT);
    var q = card.querySelector("[data-tquote]"); if (q) q.textContent = btn.getAttribute("data-quote") || "";
    var attr = btn.getAttribute("data-attr") || "";
    var a = card.querySelector("[data-tattr]"); if (a) { a.textContent = attr; a.style.display = attr ? "block" : "none"; }
    var ph = card.querySelector("[data-tphoto]");
    if (ph) {
      var src = btn.getAttribute("data-photo") || "";
      if (src) { ph.src = src; ph.style.display = "block"; } else { ph.removeAttribute("src"); ph.style.display = "none"; }
    }
    var link = card.querySelector("[data-tlink]");
    if (link) link.setAttribute("href", btn.getAttribute("data-href") || link.getAttribute("href"));

    marqueePause(true);
    var host = card.parentElement.getBoundingClientRect();
    var br = btn.getBoundingClientRect();
    var cw = card.offsetWidth || 320;
    var ch = card.offsetHeight || 170;
    var left = br.left - host.left - 22;
    left = Math.max(0, Math.min(left, Math.max(0, host.width - cw)));
    card.style.left = left + "px";
    var vh = window.innerHeight || 800;
    var below = br.bottom + 16 + ch <= vh - 12;
    var top = below ? (br.bottom - host.top + 16) : (br.top - host.top - ch - 14);
    card.style.top = top + "px";
    card.style.opacity = "1";
    card.style.transform = "translateY(0)";
    card.style.pointerEvents = "auto";
    card.setAttribute("aria-hidden", "false");
    // The section paints inside its own stacking context (z-index:3); the next
    // rounded sheet sits above it in the DOM and would clip the floating quote
    // card's lower half. Lift the whole clientele section while a card is open so
    // it renders on top; quoteHide() restores the base z-index.
    clients.style.zIndex = "60";
  }
  function quoteHide() {
    if (!clients) return;
    var card = $("[data-tcard]", clients);
    if (!card) return;
    window.clearTimeout(qT);
    qT = window.setTimeout(function () {
      card.style.opacity = "0";
      card.style.transform = "translateY(6px)";
      card.style.pointerEvents = "none";
      card.setAttribute("aria-hidden", "true");
      clients.style.zIndex = "3";
      marqueePause(false);
    }, 180);
  }
  if (clients) {
    if (reduced) {
      $$("[data-marquee]", clients).forEach(function (t) { t.style.animation = "none"; });
      $$("[data-row]", clients).forEach(function (r) { r.style.overflowX = "auto"; });
    }
    $$("[data-row]", clients).forEach(function (row) {
      row.addEventListener("mouseenter", function () {
        var t = row.querySelector("[data-marquee]"); if (t) t.style.animationPlayState = "paused";
      });
      row.addEventListener("mouseleave", function () {
        var t = row.querySelector("[data-marquee]");
        var card = $("[data-tcard]", clients);
        var open = card && card.getAttribute("aria-hidden") === "false";
        if (t && !open) t.style.animationPlayState = "running";
      });
    });
    $$("[data-quote]", clients).forEach(function (btn) {
      btn.addEventListener("mouseenter", function () { quoteShow(btn); });
      btn.addEventListener("mouseleave", quoteHide);
      btn.addEventListener("focus", function () { quoteShow(btn); });
      btn.addEventListener("blur", quoteHide);
    });
    var tcard = $("[data-tcard]", clients);
    if (tcard) {
      tcard.addEventListener("mouseenter", function () { window.clearTimeout(qT); });
      tcard.addEventListener("mouseleave", quoteHide);
    }
  }

  /* ======================= insights card hover ========================== */
  function cardHover(el, on) {
    var img = el.querySelector("[data-ci]"); if (img) img.style.transform = on ? "scale(1.055)" : "scale(1)";
    var tint = el.querySelector("[data-ct]"); if (tint) tint.style.opacity = on ? "1" : "0";
    var arrow = el.querySelector("[data-ca]"); if (arrow) arrow.style.transform = on ? "translateX(7px)" : "translateX(0)";
  }
  $$("[data-icard]").forEach(function (el) {
    el.addEventListener("mouseenter", function () { cardHover(el, true); });
    el.addEventListener("mouseleave", function () { cardHover(el, false); });
  });

  /* ======================= closing CTA rise ============================= */
  var cta = $("#ff-begin");
  function riseCta() {
    if (!cta) return;
    $$("[data-rise]", cta).forEach(function (el) { el.style.opacity = "1"; el.style.transform = "none"; });
  }
  if (cta) {
    if (reduced || !("IntersectionObserver" in window)) { riseCta(); }
    else {
      var co = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (e) { if (e.isIntersecting) { riseCta(); obs.disconnect(); } });
      }, { threshold: 0.22 });
      co.observe(cta);
    }
  }

  /* ======================= resize ======================================= */
  window.addEventListener("resize", function () {
    layoutCanvas();
    sizeFabric();
    if (ctx) start();
  });
})();
